import {
    createLazyComponent,
    LazyModule,
    LazyAction,
    LazyImport,
    LazyModuleType,
} from 'owa-bundling';
import { Loading, NetworkError } from 'owa-timestream-loadingpanel';
import type { CalendarBoardProps } from './schema';

const lazyModule = new LazyModule(
    () => import(/* webpackChunkName: "CalendarBoard" */ './lazyIndex')
);

export const CalendarBoard = createLazyComponent<
    CalendarBoardProps,
    LazyModuleType<typeof lazyModule>,
    {}
>(lazyModule, m => m.CalendarBoard, Loading, NetworkError);

export const lazyBootstrapCalendarBoard = new LazyAction(lazyModule, m => m.bootstrapCalendarBoard);

export const lazyOpenBoardProject = new LazyAction(lazyModule, m => m.openTimeStreamProject);

export const lazyClearSelectedAssets = new LazyAction(lazyModule, m => m.clearSelectedAssets);

export const lazyGetSelectedAssets = new LazyAction(lazyModule, m => m.getSelectedAssets);

export const lazyHasSelectedProject = new LazyImport(lazyModule, m => m.hasSelectedProject);

export const lazyGetSelectedProjectId = new LazyImport(lazyModule, m => m.getSelectedProjectId);

export type { CalendarBoardHandle } from './schema';
